// @mui material components
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";

function Footer() {
  const currentYear = new Date().getFullYear();
  return (
    <MDBox component="footer" py={2} display="flex" justifyContent="center">
      <MDTypography variant="button" fontWeight="regular" color="text">
        &copy; {currentYear} FAST
      </MDTypography>
    </MDBox>
  );
}

export default Footer;
